<template>
    <v-navigation-drawer app permanent fixed dark color="primary" :width="width">
        <v-container fluid fill-height class="pa-0 ma-0">
            <v-list width="100%" class="pa-0 mx-0 list-bg" color="white">
                <v-list-item-group>
                    <v-list-item class="item-bg" id="elem_home_be" disabled> </v-list-item>
                    <v-list-item
                        link
                        class="pa-0 item-bg"
                        color="primary"
                        :id="'elem_' + items[0].name"
                        :to="items[0].path"
                    >
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3 selected"
                            color="primary"
                            v-show="selected === 0"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[0].icon" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 py-0 py-1 pl-0 pr-5 pr-md-5 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-subtitle-1 font-weight-bold"
                                    >{{ items[0].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[0].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3"
                            color="primary"
                            v-show="selected !== 0"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[0].iconW" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 py-0 py-1 pl-0 pr-5 pr-md-5 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-subtitle-1 font-weight-bold"
                                    >{{ items[0].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-subtitle-1 color-subtitle"
                                    >{{ items[0].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                    </v-list-item>
                    <v-list-item class="item-bg" id="elem_home_af" disabled> </v-list-item>
                </v-list-item-group>
            </v-list>

            <v-list width="100%" class="pa-0 mx-0 list-bg" color="white">
                <v-list-item-group>
                    <v-list-item class="item-bg" id="elem_list_fi" disabled> </v-list-item>

                    <v-list-item
                        link
                        class="pa-0 item-bg"
                        color="primary"
                        :id="'elem_' + items[1].name"
                        :to="items[1].path"
                    >
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3 selected"
                            color="primary"
                            v-show="selected === 1"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[1].icon" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 py-0 py-1 pl-0 pr-4 pr-md-5 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-subtitle-1 font-weight-bold"
                                    >{{ items[1].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[1].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3"
                            color="primary"
                            v-show="selected !== 1"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[1].iconW" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 py-0 py-1 pl-0 pr-4 pr-md-5 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-subtitle-1 font-weight-bold"
                                    >{{ items[1].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[1].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                    </v-list-item>

                    <v-list-item
                        link
                        class="pa-0 item-bg"
                        color="primary"
                        :id="'elem_' + items[2].name"
                        :to="items[2].path"
                    >
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3 selected"
                            color="primary"
                            v-show="selected === 2"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[2].icon" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 py-1 pl-0 pr-3 pr-md-3 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-subtitle-1 font-weight-bold"
                                    >{{ items[2].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[2].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3"
                            color="primary"
                            v-show="selected !== 2"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[2].iconW" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 py-1 pl-0 pr-3 pr-md-3 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-subtitle-1 font-weight-bold"
                                    >{{ items[2].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[2].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                    </v-list-item>

                    <v-list-item
                        link
                        class="pa-0 item-bg"
                        color="primary"
                        :id="'elem_' + items[3].name"
                        :to="items[3].path"
                    >
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3 selected"
                            color="primary"
                            v-show="selected === 3"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[3].icon" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 pl-0 py-1 pl-0 pr-5 pr-md-5 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-body-2 font-weight-bold"
                                    >{{ items[3].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[3].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                        <v-row
                            class="py-1 py-md-2 px-0 ml-3"
                            color="primary"
                            v-show="selected !== 3"
                        >
                            <v-col
                                cols="12"
                                class="ma-0 py-0 pr-0 pl-3 pl-sm-5 pl-md-8 pl-lg-10 pl-xl-11"
                            >
                                <v-img :src="items[3].iconW" height="30" width="30"></v-img>
                            </v-col>
                            <v-col cols="12" class="ma-0 pl-0 py-1 pl-0 pr-5 pr-md-5 pr-lg-6">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-body-2 font-weight-bold"
                                    >{{ items[3].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[3].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                    </v-list-item>

                    <v-list-item class="item-bg" id="elem_list_la" disabled> </v-list-item>
                </v-list-item-group>
            </v-list>

            <v-list width="100%" class="pa-0 mx-0">
                <v-list-item-group>
                    <v-list-item link class="py-1 py-md-3 px-0 ma-0" @click="logOut">
                        <v-row>
                            <v-col cols="12" class="ma-0 py-0 pl-2 pl-md-0 pr-0">
                                <v-icon>{{ items[4].icon }}</v-icon>
                            </v-col>
                            <v-col cols="12" class="ma-0 py-1 pl-2 pl-md-0 pr-sm-0 pr-md-0 pr-lg-0">
                                <v-list-item-title
                                    class="py-md-1 text-caption text-md-body-2 font-weight-bold"
                                    >{{ items[4].title }}</v-list-item-title
                                >
                                <v-list-item-title
                                    class="font-italic text-caption text-md-body-2 color-subtitle"
                                    >{{ items[4].trasl }}</v-list-item-title
                                >
                            </v-col>
                        </v-row>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-container>
    </v-navigation-drawer>
</template>

<script>
import accessHistory from '@/services/accessHistory'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            elementBeforeHome: {},
            elementHome: {},
            elementAfterHome: {},
            elementLibrary: {},
            elementChallenge: {},
            elementStore: {},
            selected: null,
        }
    },
    mounted() {
        this.setElements()

        switch (this.$router.currentRoute.path) {
            case '/user/library':
                this.setLibrary()
                break
            case '/user/challenge':
                this.setChallenge()
                break
            case '/user/store':
                this.setStore()
                break
            case '/user/home':
                this.setHome()
                break
            default:
                this.selected = -1
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
        }),
        items() {
            return [
                {
                    title: this.$t('navigation.home'),
                    trasl: this.$i18n.locale === 'es' ? 'Home' : 'Inicio',
                    icon: '/img/user/home.svg',
                    iconW: '/img/user/home-w.svg',
                    path: '/user/home',
                    name: 'home',
                },
                {
                    title: this.$t('navigation.library'),
                    trasl: this.$i18n.locale === 'es' ? 'Library' : 'Biblioteca',
                    icon: '/img/user/library.svg',
                    iconW: '/img/user/library-w.svg',
                    path: '/user/library',
                    name: 'library',
                },
                {
                    title: this.$t('navigation.challenges'),
                    trasl: this.$i18n.locale === 'es' ? 'Challenges' : 'Desafíos',
                    icon: '/img/user/challenges.svg',
                    iconW: '/img/user/challenges-w.svg',
                    path: '/user/challenge',
                    name: 'challenge',
                },
                {
                    title: this.$t('navigation.store'),
                    trasl: this.$i18n.locale === 'es' ? 'Store' : 'Tienda',
                    icon: '/img/user/store.svg',
                    iconW: '/img/user/store-w.svg',
                    path: '/user/store',
                    name: 'store',
                },
                {
                    title: this.$t('navigation.logout'),
                    trasl: this.$i18n.locale === 'es' ? 'Log out' : 'Salir',
                    icon: 'mdi-logout mdi-rotate-180',
                    path: '',
                    name: 'logout',
                },
            ]
        },
        width() {
            if (this.$vuetify.breakpoint.xs) {
                return 70
            }
            if (this.$vuetify.breakpoint.sm) {
                return 90
            }
            if (this.$vuetify.breakpoint.lg) {
                return 130
            }
            if (this.$vuetify.breakpoint.xl) {
                return 140
            }
            return 115
        },
    },
    methods: {
        setElements() {
            this.elementBeforeHome = document.getElementById('elem_home_be')
            this.elementHome = document.getElementById('elem_home')
            this.elementAfterHome = document.getElementById('elem_home_af')
            this.elementListFirst = document.getElementById('elem_list_fi')
            this.elementLibrary = document.getElementById('elem_library')
            this.elementChallenge = document.getElementById('elem_challenge')
            this.elementStore = document.getElementById('elem_store')
            this.elementListLast = document.getElementById('elem_list_la')
        },
        cleanHome() {
            this.elementBeforeHome.classList.remove('brb')
            this.elementAfterHome.classList.remove('brt')
        },
        cleanLibrary() {
            this.elementListFirst.classList.remove('brb')
            this.elementChallenge.classList.remove('brt')
        },
        cleanChallenge() {
            this.elementLibrary.classList.remove('brb')
            this.elementStore.classList.remove('brt')
        },
        cleanStore() {
            this.elementChallenge.classList.remove('brb')
            this.elementListLast.classList.remove('brt')
        },
        setHome() {
            this.elementBeforeHome.classList.add('brb')
            this.elementAfterHome.classList.add('brt')
            this.selected = 0
        },
        setLibrary() {
            this.elementListFirst.classList.add('brb')
            this.elementChallenge.classList.add('brt')
            this.selected = 1
        },
        setChallenge() {
            this.elementLibrary.classList.add('brb')
            this.elementStore.classList.add('brt')
            this.selected = 2
        },
        setStore() {
            this.elementChallenge.classList.add('brb')
            this.elementListLast.classList.add('brt')
            this.selected = 3
        },
        async logOut() {
            const vm = this
            this.$modal.confirm(
                'Confirmar',
                '¿Estás seguro de cerrar tu sesión?, todo progreso no guardado no sera sincronizado',
                async () => {
                    await accessHistory.setLogout({ userId: this.user.id })
                        .then((response) => console.info(response))
                        .catch((error) => console.error(error));
                    vm.$store.dispatch('clearSession').then(() => {
                        setTimeout(() => {
                            window.location.href = process.env.VUE_APP_BEEREADERS_LOGIN_URL
                        }, 100)
                    })
                }
            )
        },
    },
    watch: {
        $route(to, from) {
            switch (from.path) {
                case '/user/library':
                    this.cleanLibrary()
                    break
                case '/user/challenge':
                    this.cleanChallenge()
                    break
                case '/user/store':
                    this.cleanStore()
                    break
                case '/user/home':
                    this.cleanHome()
                    break
                default:
                    break
            }

            switch (to.path) {
                case '/user/library':
                    setTimeout(() => {
                        this.setLibrary()
                    }, 10)
                    break
                case '/user/challenge':
                    setTimeout(() => {
                        this.setChallenge()
                    }, 10)
                    break
                case '/user/store':
                    setTimeout(() => {
                        this.setStore()
                    }, 10)
                    break
                case '/user/home':
                    setTimeout(() => {
                        this.setHome()
                    }, 10)
                    break
                default:
                    this.selected = -1
            }
        },
    },
}
</script>
<style scoped>
.color-subtitle {
    color: #aaa2ca;
}
.item-bg {
    background-color: #514773;
}

.list-bg {
    background-color: white;
}

.selected {
    background-color: white;
    border-bottom-left-radius: 60px;
    border-top-left-radius: 60px;
}

.v-list-item {
    min-height: 24px;
}

.v-list-item:before {
    background-color: white;
    border-bottom-left-radius: 60px;
    border-top-left-radius: 60px;
    margin-left: 12px;
}

.brt {
    background-color: #514773;
    border-top-right-radius: 30px;
}

.brb {
    background-color: #514773;
    border-bottom-right-radius: 30px;
}
</style>
